import React, { useState, useEffect } from "react";
import { Row, Card, CardBody, Button, Label, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { ToastContainer, toast, Bounce } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";


const AddCertificateRegistration = () => {
  const navigate = useNavigate();
  document.title = "Technical Hub | AddCertificateRegistration";
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [addedby, setAddedBy] = useState("");
  const [seats, setSeats] = useState("");
  const [remarks, setRemarks] = useState("");
  const [eligibleRollNos, setEligibleRollNos] = useState("");
  const [eligibleColleges, setEligibleColleges] = useState("");
  const [eligibleBranches, setEligibleBranches] = useState("");
  const [eligibleYears, setEligibleYears] = useState("");
  const [registrationEndDate, setRegistrationEndDate] = useState("");
  const [slots, setSlots] = useState([
    { slot: 1, capacity: "", time: "", day: "" }
  ]);

  useEffect(() => {
    const curr_user = JSON.parse(localStorage.getItem('authUser'));
    if (curr_user) {
      setAddedBy(curr_user.first_name);
    }
    getCertificate();
  }, []);

  const getCertificate = async () => {
    try {
      const response = await axios.get(`${backendUrl}get-certifications`);
      if (response.status === 200) {
        const certificationNames = response.data.map(item => ({
          label: item.certification_name,
          value: item.certification_name
        }));
        setCourses(certificationNames);
      }
    } catch (err) {
      console.log(err);
      toast.error("Failed to load certifications");
    }
  };

  const handleSlotChange = (index, field, value) => {
    const newSlots = [...slots];
    newSlots[index][field] = value;
    setSlots(newSlots);
  };

  const addSlot = () => {
    const newSlotNumber = slots.length + 1;
    setSlots([...slots, { slot: newSlotNumber, capacity: "", time: "", day: "" }]);
  };

  const removeSlot = (index) => {
    if (slots.length <= 1) {
      toast.error("At least one slot is required");
      return;
    }
    const newSlots = [...slots];
    newSlots.splice(index, 1);
    // Renumber the slots
    const renumberedSlots = newSlots.map((slot, idx) => ({
      ...slot,
      slot: idx + 1
    }));
    setSlots(renumberedSlots);
  };

  const handleSelectedCourse = (selectedOption) => {
    setSelectedCourse(selectedOption);
  };

  const handleSubmit = async (event, values) => {
    event.preventDefault();
    const requestData = {
      certificate_name: selectedCourse.value,
      seats: parseInt(seats, 10),
      eligible_college: eligibleColleges.split(',').map(item => item.trim()),
      eligible_branch: eligibleBranches.split(',').map(item => item.trim()),
      eligible_passoutyear: eligibleYears.split(',').map(item => parseInt(item.trim(), 10)),
      slots: slots.map(slot => ({
        slot: slot.slot,
        capacity: parseInt(slot.capacity, 10),
        time: slot.time,
        day: slot.day
      })),
      eligible_rollNos: eligibleRollNos ? eligibleRollNos.split(',').map(item => item.trim()) : [],
      Remarks: remarks,
      added_by: addedby,
      end_date: new Date(registrationEndDate).toISOString()
    };

    try {
      const response = await axios.post(
        `${backendUrl}create-certificate-registration`,
        requestData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 201) {

        toast.success("Certification registration created successfully!");
        navigate("/certifications-registration-list");
      }
    } catch (error) {
      console.error("Error creating certification registration:", error);
      if (error.response) {
        console.error("Server response:", error.response.data);
        toast.error(`Error: ${error.response.data.message || "Please try again."}`);
      } else {
        toast.error("Error creating certificate registration. Please try again.");
      }
    }
  };

  return (
    <React.Fragment>
      <Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <Col xl="12">
          <Card>
            <CardBody>
              <h4 className="card-title">ADD Certification Registration Data</h4>
              <AvForm className="needs-validation" onValidSubmit={handleSubmit}>
                <Row>
                  <Col md="4">
                    <div className="mb-4">
                      <Label htmlFor="course">Select Certificate Name <span className="text-danger">*</span></Label>
                      <Select
                        value={selectedCourse}
                        onChange={handleSelectedCourse}
                        options={courses}
                        classNamePrefix="select2-selection"
                        required
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-4">
                      <Label htmlFor="seats">Seats <span className="text-danger">*</span></Label>
                      <AvField
                        name="seats"
                        placeholder="Enter Seats"
                        type="number"
                        className="form-control"
                        id="seats"
                        value={seats}
                        onChange={(e) => setSeats(e.target.value)}
                        validate={{
                          required: { value: true, errorMessage: "Seats are required" },
                          min: { value: 1, errorMessage: "Must have at least 1 seat" }
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="4">
                    <div className="mb-4">
                      <Label htmlFor="registration-end-date">Registration End Date <span className="text-danger">*</span></Label>
                      <AvField
                        name="registration-end-date"
                        type="date"
                        className="form-control"
                        id="registration-end-date"
                        value={registrationEndDate}
                        onChange={(e) => setRegistrationEndDate(e.target.value)}
                        validate={{
                          required: { value: true, errorMessage: "End date is required" }
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="roll-nos">Eligible Roll Nos</Label>
                      <AvField
                        tag="textarea"
                        name="eligible_rollnos"
                        id="roll-nos"
                        rows="3"
                        placeholder="Enter roll numbers separated by commas (e.g. 101, 102)"
                        className="form-control"
                        value={eligibleRollNos}
                        onChange={(e) => setEligibleRollNos(e.target.value)}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="colleges">Eligible Colleges <span className="text-danger">*</span></Label>
                      <AvField
                        tag="textarea"
                        id="colleges"
                        name="colleges"
                        className="form-control"
                        rows="3"
                        placeholder="Enter colleges separated by commas (e.g., AEC, ABC College)"
                        value={eligibleColleges}
                        onChange={(e) => setEligibleColleges(e.target.value)}
                        validate={{
                          required: { value: true, errorMessage: "At least one college is required" }
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="branches">Eligible Branches <span className="text-danger">*</span></Label>
                      <AvField
                        tag="textarea"
                        id="branches"
                        name="branches"
                        className="form-control"
                        rows="3"
                        placeholder="Enter branches separated by commas (e.g., CSE, ECE, EEE)"
                        value={eligibleBranches}
                        onChange={(e) => setEligibleBranches(e.target.value)}
                        validate={{
                          required: { value: true, errorMessage: "At least one branch is required" }
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-4">
                      <Label htmlFor="years">Eligible Passout Years <span className="text-danger">*</span></Label>
                      <AvField
                        tag="textarea"
                        id="years"
                        name="years"
                        className="form-control"
                        rows="3"
                        placeholder="Enter years separated by commas (e.g., 2024, 2025)"
                        value={eligibleYears}
                        onChange={(e) => setEligibleYears(e.target.value)}
                        validate={{
                          required: { value: true, errorMessage: "At least one year is required" },
                          pattern: {
                            value: /^(\d{4})(\s*,\s*\d{4})*$/,
                            errorMessage: "Please enter valid years separated by commas (e.g., 2024, 2025)"
                          }
                        }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <div className="mb-4">
                      <Label htmlFor="slots">Slots <span className="text-danger">*</span></Label>
                      {slots.map((slot, index) => (
                        <div key={index} className="border rounded p-3 mb-3">
                          <h6>Slot #{slot.slot}</h6>
                          <Row>
                            <Col md="3">
                              <AvField
                                name={`slots[${index}].capacity`}
                                placeholder="Capacity"
                                type="number"
                                className="form-control mb-2"
                                value={slot.capacity}
                                onChange={(e) => handleSlotChange(index, "capacity", e.target.value)}
                                validate={{
                                  required: { value: true, errorMessage: "Capacity is required" },
                                  min: { value: 1, errorMessage: "Capacity must be at least 1" }
                                }}
                              />
                            </Col>
                            <Col md="3">
                              <AvField
                                name={`slots[${index}].time`}
                                placeholder="Time (e.g., 9:00 AM - 11:00 AM)"
                                type="text"
                                className="form-control mb-2"
                                value={slot.time}
                                onChange={(e) => handleSlotChange(index, "time", e.target.value)}
                                validate={{
                                  required: { value: true, errorMessage: "Time is required" }
                                }}
                              />
                            </Col>
                            <Col md="3">
                              <AvField
                                name={`slots[${index}].day`}
                                placeholder="Day (e.g., Monday, Wednesday)"
                                type="text"
                                className="form-control mb-2"
                                value={slot.day}
                                onChange={(e) => handleSlotChange(index, "", e.target.value)}
                                validate={{
                                  required: { value: true, errorMessage: "Day are required" }
                                }}
                              />
                            </Col>
                            <Col md="3" className="d-flex align-items-end">
                              {slots.length > 1 && (
                                <Button color="danger" size="sm" onClick={() => removeSlot(index)}>
                                  Remove Slot
                                </Button>
                              )}
                            </Col>
                          </Row>
                        </div>
                      ))}
                      <Button color="primary" size="sm" onClick={addSlot}>
                        + Add Slot
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <div className="mb-4">
                      <Label htmlFor="remarks">Remarks</Label>
                      <AvField
                        tag="textarea"
                        name="remarks"
                        placeholder="Enter Remarks"
                        className="form-control"
                        id="remarks"
                        rows="3"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                      />
                    </div>
                  </Col>
                </Row>

                <div className="d-flex gap-2">
                  <Button color="primary" onclick={() => navigate("/certifications-registration-list")} type="submit">
                    Submit
                  </Button>
                  {/* <Button color="secondary" onClick={() => navigate("/certification-registrations-list")}>
                    Cancel
                  </Button> */}
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AddCertificateRegistration;
